import logo from "./logo.webp";

export function Logo() {
  return (
    <div>
      <img src={logo} alt="Panoscape Logo" />
    </div>
  );
}
